// import React from "react";
import React, { useRef, useState } from "react";
// import Img
import Img from "../../assets/img/common/video-n.jpg";
// import video from "../../assets/video/polani.mp4"
// Import Icon
import Icon from "../../assets/img/icon/exp-sm-1.png";
import Icon2 from "../../assets/img/icon/exp-sm-2.png";
import Icon3 from "../../assets/img/icon/exp-sm-3.png";

// import React, { useRef, useState } from 'react'
import video from "../../assets/video/polani-company.mp4";
import PartnersSlide from "../PartnersSlide";
// import Img from "../../assets/images/your-fallback-image.jpg" // Ensure you have a fallback image

const VideoAreaTwo = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };
  const data = [
    {
      img: Icon,
      heading: "Lowest price guaranteed",
      para: "Best rates guaranteed on luxury travel through our exclusive partnerships. We match any comparable price for premium experiences.",
    },
    {
      img: Icon2,
      heading: "Easy and quick booking",
      para: "Modern booking platform for instant reservations and itineraries. Book your perfect trip in minutes with real-time confirmation.",
    },
    {
      img: Icon3,
      heading: "24/7 Customer support",
      para: "Round-the-clock concierge service for all your travel needs. Our expert team ensures seamless assistance whenever you need it.",
    },
  ];
  return (
    <>
      <section
        id="video_area_two"
        className="mt-5 section_padding nosectionpadding no-mt-5"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="video_two_left_side">
                <h2>House of Polani </h2>
                <p>
                  Experience travel excellence through our comprehensive suite
                  of services. Our platform seamlessly integrates luxury travel
                  planning with modern convenience, offering carefully curated
                  options for flights, premium accommodations, and exclusive
                  transportation. Every journey with House of Polani is a
                  testament to our commitment to exceptional service.{" "}
                </p>
                <div className="video_exp_wrapper">
                  {data.map((data1, index) => (
                    <div className="video_exp_item" key={index}>
                      <div className="video_exp_icon">
                        <img src={data1.img} alt="icon" />
                      </div>
                      <div className="video_exp_text">
                        <h3>{data1.heading}</h3>
                        <p>{data1.para}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* import video from "../../assets/video/polani.mp4"
                <div className="col-lg-6">
                    <div className="video_two_right_side">
                        <img src={Img} alt="img"/>
                        <div className="video_two_play_area">
                            <a className="video_btn video_play_area"  href="#!"
                                title="Youtube Video"><i className="fas fa-play"></i></a>
                        </div>
                    </div>
                   
                </div> */}

            <div className="col-lg-6">
              <div className="video_two_right_side">
                <div className="video_container">
                  <video
                    ref={videoRef}
                    src={video}
                    poster={Img} // Use the image as a poster/thumbnail
                    controls // Add native video controls
                    width="100%" // Make video responsive
                    height="auto"
                    className="video_element"
                    style={{ borderRadius: "10px" }}
                  >
                    Your browser does not support the video tag.
                  </video>

                  {/* Optional: Custom play/pause button if you want more styling */}
                  {/* <button onClick={togglePlay} className="custom-video-control">
            {isPlaying ? 'Pause' : 'Play'}
          </button> */}
                </div>
              </div>
              <div className="PartnersSlide">
                <PartnersSlide />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VideoAreaTwo;
